module.exports = __webpack_public_path__ + "media/ipars.c9a788e4.mp4";